<script setup lang="ts">
import type { SpinDeliveryStatus } from '@/types/roulette';

const { status, compact = false } = defineProps<{
  status: SpinDeliveryStatus;
  // Rótulos curtos pra contexto de lista (histórico), onde o pill não pode
  // quebrar linha nem dominar a largura do item.
  compact?: boolean;
}>();

// Entrega agora é SÍNCRONA: a vitória só volta do /spin depois de creditada, então
// o badge do popup é sempre "delivered". "pending"/"failed" ficam só por
// compatibilidade com linhas antigas do histórico (registros pré-migração).
const MAP: Record<
  SpinDeliveryStatus,
  { label: string; compactLabel: string; cls: string }
> = {
  pending: {
    label: 'Será creditado em instantes',
    compactLabel: 'Pendente',
    cls: 'is-pending',
  },
  delivered: {
    label: 'Creditado na sua conta',
    compactLabel: 'Creditado',
    cls: 'is-delivered',
  },
  failed: {
    label: 'Estamos processando seu prêmio',
    compactLabel: 'Processando',
    cls: 'is-pending',
  },
};

const info = computed(() => {
  const entry = MAP[status] ?? MAP.pending;

  return { label: compact ? entry.compactLabel : entry.label, cls: entry.cls };
});
</script>

<template>
  <span
    class="rlt-badge"
    :class="info.cls"
  >
    {{ info.label }}
  </span>
</template>

<style scoped lang="scss">
.rlt-badge {
  @apply inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold whitespace-nowrap shrink-0;
}

.is-pending {
  background: rgba(250, 204, 21, 0.18);
  color: #fde047;
}

.is-delivered {
  background: rgba(74, 222, 128, 0.18);
  color: #86efac;
}
</style>
